"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var element_1 = require("./element");
var referenceObject_1 = require("./referenceObject");
/**
 * Add {className} to {el}, if it wasn't previously added, and return a unique
 * token for the transaction.
 *
 * @param el the element to add a class to
 * @param className the class to add
 */
exports.requestTokenForClass = function (el, className) {
    var newReferences = referenceObject_1.newObjectWithReferenceToClass(element_1.getClassReferences(el), className);
    el.classList.add(className);
    element_1.setClassReferences(el, newReferences);
    return newReferences.lastToken;
};
/**
 * Release a previously claimed token. Removes the associated class name if all
 * the tokens have been released.
 *
 * @param el the element to release a reference on
 * @param token the token to release
 */
exports.releaseToken = function (el, token) {
    var _a;
    var newReferences = referenceObject_1.newObjectWithoutReferenceToToken(element_1.getClassReferences(el), token);
    // `newObjectWithoutReferenceToId` won't immediately remove empty lists
    // from `classes`.
    var removable = Object.entries(newReferences.classes)
        .filter(function (_a) {
        var _ = _a[0], values = _a[1];
        return values.length === 0;
    })
        .map(function (_a) {
        var key = _a[0];
        return key;
    });
    (_a = el.classList).remove.apply(_a, removable);
    element_1.setClassReferences(el, newReferences);
};
//# sourceMappingURL=index.js.map